'use strict';

/**
 * function used to copy text on clipboard
 * @param {string} text - text to copy
 */
function copyToClipboard(text) {
    var $temp = $('<input>');
    $('body').append($temp);
    $temp.val(text).select();
    document.execCommand('copy');
    $temp.remove();
}

// eslint-disable-next-line require-jsdoc
function createCookie(name, value, minutes) {
    var expires;
    if (minutes) {
        var date = new Date();
        date.setTime(date.getTime() + minutes * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/;SameSite=Strict';
}
/**
 * The selected code creates a function that gets the value of a cookie with a given name. It uses the split method to split the cookie string into an array of cookies, and then loops through each cookie in the array to check if the name of the cookie matches the given name. If a match is found, the function decodes the value of the cookie and returns it.
 * @param {*} cookieName  The name of the cookie to get the value of.
 * @returns {string | null}  the name
 */
function getCookie(cookieName) {
    let cookies = document.cookie;
    let cookieArray = cookies.split('; ');

    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        let [name, value] = cookie.split('=');

        if (name === cookieName) {
            return decodeURIComponent(value);
        }
    }

    return 'false';
}

/**
 * function used to handle lead generation
 * @returns {boolean}  false
 */
function handleLeadGeneration() {
    // set cookie to not open the popup
    var subscriptionemail = $('#subscriptionemail').val();
    if (subscriptionemail === '') {
        $('#subscriptionemail')
            .siblings('.invalid-feedback')
            .text('please enter the email')
            .show()
            .css('color', '#8A181A');
        return false;
    }
    var actionURL = $('#subscriptionemail').data('action');
    if (actionURL) {
        var recaptchaSiteKey = $('.js-generate-lead-from-popup').data(
            'recaptcha-site-key'
        );
        if (recaptchaSiteKey !== '') {
            // eslint-disable-next-line no-undef
            grecaptcha.ready(function () {
                // eslint-disable-next-line no-undef
                grecaptcha
                    .execute(recaptchaSiteKey, { action: 'submit' })
                    .then(function (token) {
                        $.ajax({
                            url: actionURL,
                            type: 'POST',
                            data: {
                                subscriptionemail: subscriptionemail,
                                recaptchaToken: token,
                            },
                            success: function (response) {
                                $('#subscriptionemail')
                                    .siblings('.invalid-feedback')
                                    .text(response.message);
                                if (response.success) {
                                    $('#subscriptionemail').val('');
                                    // hide all the first step data
                                    $('.right-mid-image').hide();
                                    $('.banner-text').hide();
                                    $('.banner-email-form').hide();
                                    $('.js-generate-lead-from-popup').hide();
                                    $('.close-btn').hide();
                                    $('.js-success-content').show().removeClass('d-none');
                                    createCookie('newsletter-close', 'true', 525960);
                                    // $('#subscriptionemail')
                                    //     .siblings('.invalid-feedback')
                                    //     .show()
                                    //     .css('color', 'green');
                                } else {
                                    $('#subscriptionemail')
                                        .siblings('.invalid-feedback')
                                        .show()
                                        .css('color', '#8A181A');
                                }
                            },
                        });
                    });
            });
        } else {
            $('#subscriptionemail')
                .siblings('.invalid-feedback')
                .text('Something went wrong. Please try again later.')
                .show()
                .css('color', '#8A181A');
            return false;
        }
    }
    return true;
}

module.exports = {
    init: function () {
        $(document).ready(function () {
            // logic to open newsletter popup
            var newsletterClose = getCookie('newsletter-close');
            if (newsletterClose === 'false') {
                if (document.getElementById('newsletter-trigger') !== null) {
                    document.getElementById('newsletter-trigger').click();
                }
            }
        });
    },
    closeNewLetterPopup: function () {
        $(document).on('click', '.js-close-newsletter-popup', function () {
            createCookie('newsletter-close', 'true', 1440);
            if (document.getElementById('newsletter-trigger') !== null) {
                document.getElementById('newsletter-trigger').click();
            }
        });
    },
    handleLeadGeneration: function () {
        // eslint-disable-next-line consistent-return
        $(document).on('click', '.js-generate-lead-from-popup', function () {
            handleLeadGeneration();
        });
    },
    newsletterPopupShoppingButton: function () {
        $(document).on('click', '.js-shopping-button', function (e) {
            e.preventDefault();
            var link = $(this).data('href');
            if (
                link !== '' &&
				link !== null &&
				link !== undefined &&
				link !== 'null'
            ) {
                window.location.href = link;
            } else {
                // eslint-disable-next-line no-lonely-if
                if (document.getElementById('newsletter-trigger') !== null) {
                    document.getElementById('newsletter-trigger').click();
                }
            }
        });
    },
    handleOutSideClick: function () {
        // If an event gets to the body
        $('body').click(function (e) {
            if (
                $('.newsletter-popup').length &&
				e.target.id !== 'newsletter-trigger'
            ) {
                createCookie('newsletter-close', 'true', 1440);
            }
        });

        // Prevent events from getting pass .popup
        // eslint-disable-next-line consistent-return
        $('.newsletter-popup .modal-content').click(function (e) {
            e.stopPropagation();

            if (e.target.className.indexOf('js-close-newsletter-popup') > -1) {
                createCookie('newsletter-close', 'true', 1440);
                if (document.getElementById('newsletter-trigger') !== null) {
                    document.getElementById('newsletter-trigger').click();
                }
                return false;
            }

            if (e.target.className.indexOf('js-generate-lead-from-popup') > -1) {
                handleLeadGeneration();
                return false;
            }
            if (e.target.className.indexOf('js-shopping-button') > -1) {
                var link = $(this).data('href');
                if ($('.coupon-code-div').length) {
                    copyToClipboard($('.coupon-code-div:visible').text());
                }
                if (
                    link !== '' &&
					link !== null &&
					link !== undefined &&
					link !== 'null'
                ) {
                    window.location.href = link;
                } else {
                    // eslint-disable-next-line no-lonely-if
                    if (document.getElementById('newsletter-trigger') !== null) {
                        document.getElementById('newsletter-trigger').click();
                    }
                }
                return false;
            }
        });
    },
};
